import { createQueryKeys } from '@lukemorales/query-key-factory'
import type { inferQueryKeys } from '@lukemorales/query-key-factory'
import type { ArticleData } from '~/types/auth'

export const userManuals = createQueryKeys('userManuals', {
  all: null,
  details: (id: ArticleData['id']) => [id],
})

export type CountryKeys = inferQueryKeys<typeof userManuals>
